import styled from 'styled-components';
import { color } from 'styles/settings';
import { withModifiers } from 'utils/styles';

export const Container = styled.div`
  background-color: ${color.neutral.grayLight};
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 188px;
  padding: 23px 0;

  color: ${({ color, selected, selectedColor }) =>
    selected ? selectedColor : color};

  ${withModifiers('selected')`
    background-color: ${({ color }) => color};
  `}

  ${withModifiers('disabled')`
    cursor: initial;
  `}
`;
